import { render, staticRenderFns } from "./AdminUsers.vue?vue&type=template&id=5f5f8d98&scoped=true"
import script from "./AdminUsers.vue?vue&type=script&lang=ts"
export * from "./AdminUsers.vue?vue&type=script&lang=ts"
import style0 from "./AdminUsers.vue?vue&type=style&index=0&id=5f5f8d98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5f8d98",
  null
  
)

export default component.exports